const formatNumberCompact = (value: number): string => {
  const units = ["", "K", "M", "B", "T"]
  const unit = Math.floor((value.toFixed(0).length - 1) / 3)
  const shortened = (value / Math.pow(1000, unit)).toFixed(2)

  return shortened + units[unit]
}

const formatMonneyCompact = (value: number, currency: string): string => {
  const currencySymbol = (0).toLocaleString('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).replace(/\d/g, '').trim()

  return formatNumberCompact(value) + currencySymbol
}

export {
  formatNumberCompact,
  formatMonneyCompact
}
